import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {EfetuacompraDetail} from "./efetuacompra-detail";

const EfetuaCompraDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/efetuacompras');
    }

    return (
        <EfetuacompraDetail id={id} onClose={onClose}/>
    )

});

export default EfetuaCompraDetailPage;